import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../service/auth.service';
import { AppConstants } from '../AppConstants';
import { BulkBookingConfirmationComponent } from '../bulk-booking-confirmation/bulk-booking-confirmation.component';
import { MatDialogRef } from '@angular/material/dialog';

interface BulkSlotData {
  uniqueId: string;
  productId: number;
  productName: string;
  venueName: string;
  price: number;
  date: string;
  startTime: string;
  endTime: string;
}

@Component({
  selector: 'app-bulk-bookings',
  templateUrl: './bulk-bookings.component.html',
  styleUrls: ['./bulk-bookings.component.css']
})
export class BulkBookingsComponent implements OnInit {

  user: any;

  products: any[] = [];
  venues: any[] = [];
  availableVenues: any[] = [];

  selectedProduct: any;
  selectedProductName = '';
  previousProductName = '';

  fromDate = '';
  toDate = '';

  /* startTime = '06:00';
  endTime = '07:00'; */

  ignoreUnavailableSlots = true;

  selectedVenueIds: number[] = [];

  selectAllCourts = true;

  sessionConfigs: any[] = [];
  venueError = '';
  successMessage = '';
  showSuccessPopup = false;


  bookingId = '';


 /*  selectedDays: string[] = []; */

  constructor(
    private authService: AuthService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<BulkBookingsComponent>
  ) {
  }

  ngOnInit(): void {

    this.user = JSON.parse(
      sessionStorage.getItem(
        AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT
      )
    );

    //this.selectedDays = [];

    const today = new Date();

    this.fromDate = today.toISOString().substring(0, 10);

    const nextMonth = new Date();
    nextMonth.setMonth(nextMonth.getMonth() + 1);

    this.toDate = nextMonth.toISOString().substring(0, 10);

    this.getAllVenuesByTenantId(this.user.tenantId);

  }

  getAllVenuesByTenantId(tenantId: number) {

    this.authService
      .getAllVenuesByTenantId(tenantId)
      .subscribe((response: any) => {

        this.venues = [];

        response.forEach(v => {

          this.venues.push({
            id: v.id,
            name: v.venueName,
            productIds: v.productIds
          });

        });

        this.getAllProductsByTenantId(tenantId);

      });

  }

  getAllProductsByTenantId(tenantId: number) {

    this.authService
      .getAllProductsByTenantId(tenantId)
      .subscribe((response: any[]) => {

        this.products = response
          .filter(p => p.productType === 'Single Session')
          .map(p => ({
            id: p.id,
            productName: p.productName,
            price: p.price,
            durationPerSlot: p.durationPerSlot,
            sessions: p.sessions
          }))
          .sort((a, b) =>
            a.productName.localeCompare(
              b.productName,
              undefined,
              {
                sensitivity: 'base',
                numeric: true
              }
            )
          );

        this.products.sort((a, b) =>
          a.productName.localeCompare(b.productName));

        if (this.products.length > 0) {

          this.selectedProduct = this.products[0];
          this.selectedProductName = this.selectedProduct.productName;
          this.previousProductName = this.selectedProductName;

          this.onProductChanged();

        }

      });

  }

  onProductChanged() {

    const newlySelectedProduct =
      this.products.find(
        x => x.productName === this.selectedProductName
      );

    if (!newlySelectedProduct) {

      return;

    }

    const venues =
      this.venues.filter(
        x =>
          x.productIds &&
          x.productIds.indexOf(
            newlySelectedProduct.id
          ) > -1
      );

      this.selectedVenueIds = [];

      this.sessionConfigs = [];

      if (venues.length === 0) {

        this.venueError =
          'No venues are attached to this service. Please attach at least one venue before proceeding with bulk booking.';

        this.selectedProduct =
          newlySelectedProduct;

        this.availableVenues = [];

        return;

      }

      this.venueError = '';

    this.previousProductName =
      this.selectedProductName;

    this.selectedProduct =
      newlySelectedProduct;

    this.availableVenues =
      venues;

    this.selectedVenueIds = [];

    this.sessionConfigs = [];

    this.selectedProduct.sessions.forEach(session => {

      let days: string[] = [];

      if (session.monday)
        days.push('Mon');

      if (session.tuesday)
        days.push('Tue');

      if (session.wednesday)
        days.push('Wed');

      if (session.thursday)
        days.push('Thu');

      if (session.friday)
        days.push('Fri');

      if (session.saturday)
        days.push('Sat');

      if (session.sunday)
        days.push('Sun');

      const startTimes: string[] =
        [...new Set<string>(
          session.timeslotWiseProduct.map(
            x => x.startTime
          )
        )]
        .sort(
          (a: string, b: string) =>
            this.convertTimeToMinutes(a)
            -
            this.convertTimeToMinutes(b)
        );

      const endTimes: string[] =
        [...new Set<string>(
          session.timeslotWiseProduct.map(
            x => x.endTime
          )
        )]
        .sort(
          (a: string, b: string) =>
            this.convertTimeToMinutes(a)
            -
            this.convertTimeToMinutes(b)
        );

      this.sessionConfigs.push({

        sessionId: session.id,

        sessionName:
          session.sessionName ||
          ('Session ' + (this.sessionConfigs.length + 1)),

        days: days,

        selectedDays: [],

        startTimes: startTimes,

        endTimes: endTimes,

        selectedStartTime: '',

        selectedEndTime: '',

        availableEndTimes: []

      });

    });

  }

  onSessionStartTimeChanged(session: any) {

    session.selectedEndTime = '';

    const startMinutes =
      this.convertTimeToMinutes(
        session.selectedStartTime
      );

    session.availableEndTimes =
      session.endTimes.filter(
        t =>
          this.convertTimeToMinutes(t)
          >
          startMinutes
      );

  }

  toggleSessionDay(session: any, day: string) {

    const idx = session.selectedDays.indexOf(day);

    if (idx > -1) {

      session.selectedDays.splice(idx, 1);

    }
    else {

      session.selectedDays.push(day);

    }

  }

/*   onProductChanged() {

    this.selectedProduct =
      this.products.find(
        x => x.productName === this.selectedProductName
      );

    this.availableVenues =
      this.venues.filter(
        x => x.productIds.indexOf(this.selectedProduct.id) > -1
      );

    this.selectedVenueIds = [];
    this.populateAvailableDays();

    this.populateAvailableStartTimes();

    this.availableEndTimes = [];

    this.selectedDays = [];

    this.startTime = '';

    this.endTime = '';

  } */

/*   populateAvailableDays() {

    this.availableDays = [];

    this.selectedProduct.sessions.forEach(session => {

      if (session.monday)
        this.availableDays.push('Mon');

      if (session.tuesday)
        this.availableDays.push('Tue');

      if (session.wednesday)
        this.availableDays.push('Wed');

      if (session.thursday)
        this.availableDays.push('Thu');

      if (session.friday)
        this.availableDays.push('Fri');

      if (session.saturday)
        this.availableDays.push('Sat');

      if (session.sunday)
        this.availableDays.push('Sun');

    });

    this.availableDays =
      [...new Set(this.availableDays)];

  } */

  /* populateAvailableStartTimes() {

    this.availableStartTimes = [];

    this.selectedProduct.sessions
      .forEach(session => {

        session.timeslotWiseProduct
          .forEach(slot => {

            this.availableStartTimes.push(
              slot.startTime
            );

          });

      });

    this.availableStartTimes =
      [...new Set(this.availableStartTimes)]
        .sort(
          (a, b) =>
            this.convertTimeToMinutes(a)
            -
            this.convertTimeToMinutes(b)
        );

  } */

/*   onStartTimeChanged() {

    this.endTime = '';

    this.availableEndTimes = [];

    const startMinutes =
      this.convertTimeToMinutes(
        this.startTime
      );

    this.selectedProduct.sessions
      .forEach(session => {

        session.timeslotWiseProduct
          .forEach(slot => {

            const endMinutes =
              this.convertTimeToMinutes(
                slot.endTime
              );

            if (
                endMinutes >
                startMinutes
            ) {

              this.availableEndTimes.push(
                slot.endTime
              );

            }

          });

      });

    this.availableEndTimes =
      [...new Set(this.availableEndTimes)]
        .sort(
          (a, b) =>
            this.convertTimeToMinutes(a)
            -
            this.convertTimeToMinutes(b)
        );

  } */

  onSelectAllCourts() {

    if (this.selectAllCourts) {

      this.selectedVenueIds = [];

      this.availableVenues.forEach(v => {
        this.selectedVenueIds.push(v.id);
      });

    }
    else {

      this.selectedVenueIds = [];

    }

  }

  toggleVenue(venueId: number) {

    const idx =
      this.selectedVenueIds.indexOf(venueId);

    if (idx > -1) {

      this.selectedVenueIds.splice(idx, 1);

    }
    else {

      this.selectedVenueIds.push(venueId);

    }

  }

  /* toggleDay(day: string) {

    const idx =
      this.selectedDays.indexOf(day);

    if (idx > -1) {

      this.selectedDays.splice(idx, 1);

    }
    else {

      this.selectedDays.push(day);

    }

  } */

reset() {

  this.selectedVenueIds = [];

  const today = new Date();

  this.fromDate =
    today.toISOString().substring(0,10);

  const nextMonth = new Date();

  nextMonth.setMonth(
    nextMonth.getMonth() + 1
  );

  this.toDate =
    nextMonth.toISOString().substring(0,10);

  this.sessionConfigs.forEach(session => {

    session.selectedDays = [];

    session.selectedStartTime = '';

    session.selectedEndTime = '';

  });

}

  convertDay(date: Date): string {

    const days =
      ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    return days[date.getDay()];

  }

  generateDateArray(selectedDays: string[]): string[] {

    let result: string[] = [];

    let current = new Date(this.fromDate);

    const end = new Date(this.toDate);

    while (current <= end) {

      const dayName = this.convertDay(current);

      if (selectedDays.indexOf(dayName) > -1) {

        result.push(
          current.toISOString().substring(0,10)
        );

      }

      current.setDate(
        current.getDate() + 1
      );

    }

    return result;

  }
/*   generateDateArray(): string[] {

    let result: string[] = [];

    let current = new Date(this.fromDate);

    const end = new Date(this.toDate);

    while (current <= end) {

      const dayName =
        this.convertDay(current);

      if (this.selectedDays.indexOf(dayName) > -1) {

        result.push(
          current.toISOString().substring(0, 10)
        );

      }

      current.setDate(
        current.getDate() + 1
      );

    }

    return result;

  } */

  removeLeadingZero(time: string): string {

    if (time.startsWith('0')) {
      return time.substring(1);
    }

    return time;

  }

  convertTimeToMinutes(time: string): number {

    if (!time) {
      return 0;
    }

    const parts = time.split(':');

    const hours = Number(parts[0]);

    const minutes = Number(parts[1]);

    return hours * 60 + minutes;

  }

  convertMinutesToTime(totalMinutes: number): string {

    const hours = Math.floor(totalMinutes / 60);

    const mins = totalMinutes % 60;

    return hours + ':' + mins.toString().padStart(2, '0');

  }
 bookNow() {

   if (this.availableVenues.length === 0) {
      alert('No venues are attached to this service.');
    return;
   }

   if (this.selectedVenueIds.length === 0) {
     alert('Please select at least one venue.');
     return;
   }

   let generatedSlots: BulkSlotData[] = [];

   let atLeastOneSessionSelected = false;



   const slotDuration =
     Number(this.selectedProduct.durationPerSlot);

   this.sessionConfigs.forEach(session => {

     if (
       session.selectedDays.length === 0 ||
       !session.selectedStartTime ||
       !session.selectedEndTime
     ) {

       return;

     }

     atLeastOneSessionSelected = true;

     const dates =
       this.generateDateArray(
         session.selectedDays
       );

     dates.forEach(date => {

       this.selectedVenueIds.forEach(venueId => {

         const venue =
           this.availableVenues.find(
             x => x.id === venueId
           );

         const overallStart =
           this.convertTimeToMinutes(
             session.selectedStartTime
           );

         const overallEnd =
           this.convertTimeToMinutes(
             session.selectedEndTime
           );

         for (
           let currentStart = overallStart;
           currentStart < overallEnd;
           currentStart += slotDuration
         ) {

           const currentEnd =
             currentStart + slotDuration;

           if (currentEnd > overallEnd) {

             break;

           }

           const slotStart =
             this.removeLeadingZero(
               this.convertMinutesToTime(
                 currentStart
               )
             );

           const slotEnd =
             this.removeLeadingZero(
               this.convertMinutesToTime(
                 currentEnd
               )
             );

           const slotDateTime = new Date(
             date + 'T' +
             slotStart.padStart(5,'0')
           );

           if (slotDateTime < new Date()) {

             continue;

           }

           const uniqueId =
             this.user.tenantId
             + '_'
             + this.selectedProduct.id
             + '_'
             + date
             + '_'
             + slotStart
             + '_'
             + slotEnd
             + '_'
             + venueId;

           const slot: BulkSlotData = {

             uniqueId,

             productId:
               this.selectedProduct.id,

             productName:
               this.selectedProduct.productName,

             venueName:
               venue.name,

             price:
               this.selectedProduct.price,

             date,

             startTime:
               slotStart,

             endTime:
               slotEnd

           };

           generatedSlots.push(
             slot
           );

         }

       });

     });

   });

   if (!atLeastOneSessionSelected) {

     alert(
       'Please select at least one session.'
     );

     return;

   }

   if (generatedSlots.length === 0) {

     alert(
       'No slots were generated.'
     );

     return;

   }

   const dialogRef =
     this.dialog.open(
       BulkBookingConfirmationComponent,
       {
           width:'700px',
           maxWidth:'95vw',
           maxHeight:'95vh',
           disableClose:true,
           data:{
               slots:generatedSlots
           }
       }
     );

    dialogRef.afterClosed()
      .subscribe(result => {

      console.log("Result =", result);

        if (result) {

          this.successMessage =
            'Bulk booking completed successfully.';

          this.bookingId =
            result.bookingId;

          this.showSuccessPopup = true;

        }

      });

 }

 closeSuccessPopup() {

   this.showSuccessPopup = false;

   this.dialogRef.close(true);

 }

/*   bookNow() {

    let generatedSlots: BulkSlotData[] = [];

    let atLeastOneSessionSelected = false;

    const slotDuration =
      Number(this.selectedProduct.durationPerSlot);

    this.sessionConfigs.forEach(session => {

      if (
        session.selectedDays.length === 0 ||
        !session.selectedStartTime ||
        !session.selectedEndTime
      ) {

        return;

      }

      const dates =
        this.generateDateArray(
          session.selectedDays
        );

      dates.forEach(date => {

        this.selectedVenueIds.forEach(venueId => {

          const venue =
            this.availableVenues.find(
              x => x.id === venueId
            );

          const overallStart =
            this.convertTimeToMinutes(
              session.selectedStartTime
            );

          const overallEnd =
            this.convertTimeToMinutes(
              session.selectedEndTime
            );

          for (
            let currentStart = overallStart;
            currentStart < overallEnd;
            currentStart += slotDuration
          ) {

            const currentEnd =
              currentStart + slotDuration;

            if (currentEnd > overallEnd) {

              break;

            }

            const slotStart =
              this.removeLeadingZero(
                this.convertMinutesToTime(
                  currentStart
                )
              );

            const slotEnd =
              this.removeLeadingZero(
                this.convertMinutesToTime(
                  currentEnd
                )
              );

            const uniqueId =
              this.user.tenantId
              + '_'
              + this.selectedProduct.id
              + '_'
              + date
              + '_'
              + slotStart
              + '_'
              + slotEnd
              + '_'
              + venueId;

            const slot: BulkSlotData = {

              uniqueId,

              productId:
                this.selectedProduct.id,

              productName:
                this.selectedProduct.productName,

              venueName:
                venue.name,

              price:
                this.selectedProduct.price,

              date,

              startTime:
                slotStart,

              endTime:
                slotEnd

            };

            generatedSlots.push(
              slot
            );

          }

        });

      });

    });

    if (generatedSlots.length === 0) {

      alert(
        'Please select at least one session, day and time.'
      );

      return;

    }

    const dialogRef =
      this.dialog.open(
        BulkBookingConfirmationComponent,
        {
          width: '700px',
          maxWidth: '95vw',
          maxHeight: '95vh',
          data: {
            slots: generatedSlots
          }
        }
      );

    dialogRef.afterClosed()
      .subscribe(result => {

        if (result) {

          this.dialogRef.close();

        }

      });

  } */
  /* bookNow() {

    let generatedSlots: BulkSlotData[] = [];

    this.sessionConfigs.forEach(session => {

      const dates =
        this.generateDateArray(
          session.selectedDays
        );

      ...
    });

    dates.forEach(date => {

      this.selectedVenueIds.forEach(venueId => {

        const venue =
          this.availableVenues.find(
            x => x.id === venueId
          );

         const slotDuration = Number(this.selectedProduct.durationPerSlot);
        console.log("slotDuration =", this.selectedProduct);

        const overallStart =
          this.convertTimeToMinutes(
            session.selectedStartTime
          );

        const overallEnd =
          this.convertTimeToMinutes(
            session.selectedEndTime
          );

        for (
            let currentStart = overallStart;
            currentStart < overallEnd;
            currentStart += slotDuration
        ) {

            const currentEnd = currentStart + slotDuration;

            if (currentEnd > overallEnd) {
                break;
            }

            const slotStart =this.removeLeadingZero(this.convertMinutesToTime(currentStart) );

            const slotEnd =this.removeLeadingZero(this.convertMinutesToTime(currentEnd) );

            console.log(
              'Slot:',
              slotStart,
              slotEnd
            );

            const uniqueId =
                this.user.tenantId
                + '_'
                + this.selectedProduct.id
                + '_'
                + date
                + '_'
                + slotStart
                + '_'
                + slotEnd
                + '_'
                + venueId;

            const slot: BulkSlotData = {

                uniqueId,

                productId: this.selectedProduct.id,

                productName: this.selectedProduct.productName,

                venueName: venue.name,

                price: this.selectedProduct.price,

                date,

                startTime: slotStart,

                endTime: slotEnd

            };

            generatedSlots.push(slot);

        }

      });

    });

    const dialogRef = this.dialog.open(
      BulkBookingConfirmationComponent,
      {
        width: '700px',
        maxWidth: '95vw',
        maxHeight: '95vh',
        data: {
          slots: generatedSlots
        }
      }
    );

    dialogRef.afterClosed().subscribe(result => {

      if (result) {

        // booking successful
        this.dialogRef.close();

      }

    });
     *//* this.dialog.open(
      BulkBookingConfirmationComponent,
      {
        width: '800px',
        maxWidth: '95vw',
        maxHeight: '95vh',
        autoFocus: false,
        restoreFocus: false,
        data: {
          slots: generatedSlots
        }
      }
    ); *//*

  } */

  cancel() {

    this.dialogRef.close();

  }

}
